import type { SliderSchemaType } from '@vedalib/editor/lib/brand'
import styled, { css } from 'styled-components'

import { outline } from 'components/Editor/styled/Outline'
import type { ElementStyleCss } from 'services/Branding/types'

const DotStyled = styled.button<{ $styles: ElementStyleCss<SliderSchemaType>; $selected: boolean }>`
  transition: 0.2s;
  flex-shrink: 0;
  border-radius: 50%;
  cursor: pointer;
  border: none;

  ${outline}

  ${({ $styles: { progress, activeColor, inactiveColor }, $selected }) => css`
    height: ${progress.height};
    width: ${progress.width};
    background-color: ${$selected ? activeColor.backgroundColor : inactiveColor.backgroundColor};
  `}
  box-shadow: ${({ $styles }) => $styles.effects.boxShadow};

  &:hover {
    background-color: ${({ $styles: { hover }, $selected }) => !$selected && hover.backgroundColor};
  }
`

export default DotStyled
